import React from 'react';

export default (props) => {
  const value = !props.data ? props.label : props.value;
  return <div>{value}</div>;
};
